(()=>{


// Keep the complete, linked collection in the HTML for fast first paint and
// browsers without JavaScript. The config is also the source for future editions.
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let observer;

function revealCollection() {
  observer?.disconnect();
  const items = [...document.getElementById('viulet-v36-collection').querySelectorAll('.reveal')];
  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    document.getElementById('viulet-v36-collection').classList.remove('motion-ready');
    items.forEach(item => item.classList.add('has-entered'));
    return;
  }
  // Content above the fold is visible immediately. Only later sections enter.
  items.forEach(item => {
    if (item.getBoundingClientRect().top < window.innerHeight) item.classList.add('has-entered');
  });
  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('has-entered');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.06, rootMargin: '0px 0px 25px 0px' });
  items.filter(item => !item.classList.contains('has-entered')).forEach(item => observer.observe(item));
  document.getElementById('viulet-v36-collection').classList.add('motion-ready');
}

revealCollection();
reducedMotion.addEventListener?.('change', revealCollection);

// Reveal focused links before an entrance animation can make them look hidden.
document.addEventListener('focusin', event => {
  event.target.closest('.reveal')?.classList.add('has-entered');
});

window.addEventListener('pageshow', event => {
  if (event.persisted) revealCollection();
});

})();